let _searchKey = sessionStorage.getItem('COUNSELOR-SEARCHKEY')
_searchKey = _searchKey && JSON.parse(_searchKey) || {hosp: {}, dept: {}}
let _initHosp = sessionStorage.getItem('INIT-HOSP')
_initHosp = _initHosp && JSON.parse(_initHosp) || {}

export default {
  state: {
    firstLog: true,
    searchKey: _searchKey, // 医生列表搜索参数
    initHosp: _initHosp // 初始化医院（区域）参数
  },
  mutations: {
    setFirstLog: (state, obj) => {
      state.firstLog = obj
    },
    setSearchKey: (state, obj) => {
      state.searchKey = obj
      sessionStorage.setItem('COUNSELOR-SEARCHKEY', JSON.stringify(obj))
    },
    setInitHosp: (state, obj) => {
      state.initHosp = obj
      sessionStorage.setItem('INIT-HOSP', JSON.stringify(obj))
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/counselor.js